import { type Dispatch, useCallback, useMemo, useState } from "react";

const _MODAL_STATUSES = ["closed", "open"] as const;
export type ModalStatus = (typeof _MODAL_STATUSES)[keyof typeof _MODAL_STATUSES];

export interface UseModalState {
  modalStatus: ModalStatus;
  setModalStatus: Dispatch<ModalStatus>;
  modalIsClosed: boolean;
  modalIsOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
}

export function useModalState(initialModalStatus: ModalStatus = "closed"): UseModalState {
  const [modalStatus, setModalStatus] = useState<ModalStatus>(initialModalStatus);

  const openModal = useCallback(() => {
    setModalStatus("open");
  }, []);
  const closeModal = useCallback(() => {
    setModalStatus("closed");
  }, []);

  return useMemo(() => {
    const modalIsClosed = modalStatus === "closed";
    const modalIsOpen = modalStatus === "open";

    return {
      modalStatus,
      setModalStatus,
      modalIsClosed,
      modalIsOpen,
      openModal,
      closeModal,
    };
  }, [modalStatus, openModal, closeModal]);
}
